import { render, staticRenderFns } from "./companyAssetsSetups.vue?vue&type=template&id=b46615ce"
import script from "./companyAssetsSetups.vue?vue&type=script&lang=js"
export * from "./companyAssetsSetups.vue?vue&type=script&lang=js"
import style0 from "./companyAssetsSetups.vue?vue&type=style&index=0&id=b46615ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports